import React from "react";
import {encrypt,decrypt} from "./CaesarFunctions"
import styled from "styled-components"

export default class Caesarview extends React.Component{
    constructor(props){
        super(props);
        this.state={
            plain: "",
            cipher: "",
            key: 1,
            keysOptions: ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26"]
        }
    }
    handleInput = (e)=> {
        let target = e.target;
        let value = target.value;
        let name = target.name;
        this.setState({
            [name]: value
        })
    }
    
    componentDidUpdate(prevProps,prevState){
        if(prevState.key!==this.state.key){
            const fromPlain = encrypt(this.state.plain.toLowerCase(),Number(this.state.key));
            this.setState({cipher: fromPlain})
        }
        if(prevState.plain!==this.state.plain){
            const fromPlain = encrypt(this.state.plain.toLowerCase(),Number(this.state.key));
            this.setState({cipher: fromPlain})
        }
        if(prevState.cipher!==this.state.cipher){
            const fromCipher = decrypt(this.state.cipher.toLowerCase(),Number(this.state.key));
            this.setState({plain: fromCipher})
        }
       
    }
  
    render(){
        //console.log()
        return(
            <CaesarWrapper>
                <div className="wrapper">
                    <h2>Chiffrement de Cesar</h2>
                    <form className="cesar-form">
                        <div className="form-group key">
                            <label className="form-label"><h3>key</h3></label>
                            <div className="input-wrapper">
                                <select 
                                    name="key"
                                    value={this.state.key}
                                    onChange={this.handleInput}
                            
                                >
                                    <option value="" disabled>choisis une cle</option>
                                    {this.state.keysOptions.map((key)=>{
                                        return(
                                        <option key={key} value={key} label={key} >{key}</option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="form-group plain">
                            <label className="form-label"><h3>PlainText</h3></label>
                            <div className="input-wrapper">
                                <textarea 
                                    rows={10}
                                    //cols={40}
                                    value={this.state.plain} 
                                    onChange={this.handleInput} 
                                    name="plain" 
                                    
                                    
                                />
                            </div>
                        </div>
                        <div className="form-group cipher">
                            <label className="form-label"><h3>Ciphertext</h3></label>
                            <div className="input-wrapper">
                                <textarea 
                                    rows={10}
                                    //cols={40}
                                    value={this.state.cipher} 
                                    onChange={this.handleInput} 
                                    name="cipher" 
                                />
                            </div>
                        </div>
                    </form>
                

                </div>
            {/* {JSON.stringify(this.state)} */}
            </CaesarWrapper>
            
        );
    }
}

const CaesarWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    max-width:1300px;
    position: relative;
    .wrapper{
        //border:  solid rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        // min-width: 350px;
        // min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .cesar-form{
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 20px;
            .plain,.cipher{
                textarea{
                    width: auto;
                    font-family: ubuntu;
                    font-size: 30px;
                    background: #27292c;
                    color: whitesmoke;
                    border: none;
                    box-shadow: 0px 0px 1px  #1ca086;
                    &:focus{
                        border: solid #1ca086;
                    }
                    @media screen and (max-width: 681px){
                        width: auto;
                    } 
                }
                
            }
            .key{
                grid-column: 1/3;
                
            }
            @media screen and (max-width: 1600px){
                display: flex;
                flex-direction: column;
            }
            
        }
        
    }

`